import { createLabeledMessages } from '../../../messageUtils';
const delegations = {
    enter: 'Vstúpiť',
    inDelegations: 'v zastúpení',
    orInDelegations: 'alebo v zastúpení',
    genericError: ' Prišlo k neočakávanej chybe.',
    userHasNoPermissions: 'Užívateľ nemá právo vstúpiť do aplikácie.',
    cannotDelegate: 'Do tejto aplikácie nemáte právo vstúpiť v zastúpení {{representativeFor}}. Budete prihlásený pod svojim menom.'
};
export default Object.assign({}, delegations, createLabeledMessages(delegations));
